import React from 'react';
import { Box, TextField, Button, Typography, CircularProgress, Switch, FormControlLabel, Chip } from '@mui/material';

function PromptInput({ prompt, setPrompt, onAnalyze, isLoading, isSourceMaterial, setIsSourceMaterial }) {
  const charCount = prompt.length;

  return (
    <Box component="section">
      {/* Character intro */}
      <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, gap: { xs: 1.5, sm: 2 } }}>
        <Box
          sx={{
            flexGrow: 1,
            position: 'relative',
            bgcolor: 'secondary.light',
            color: 'text.primary',
            p: { xs: 2, sm: 2.5 },
            borderRadius: 3,
            '&::after': {
              content: '""',
              position: 'absolute',
              right: -10,
              bottom: '25px',
              width: 0,
              height: 0,
              borderTop: '10px solid transparent',
              borderBottom: '10px solid transparent',
              borderLeft: '10px solid',
              borderLeftColor: 'secondary.light',
            },
          }}
        >
          <Typography sx={{ fontWeight: 500, fontSize: { xs: '0.875rem', sm: '1rem' } }}>
            Hi, I'm Prompter. Type or paste your best AI prompt into the box below and my friend Prim will help you make it absolutely marvelous!
          </Typography>
        </Box>
        <Box
          component="img"
          src="/prompter-character.png"
          alt="Prompter"
          sx={{
            height: { xs: '90px', sm: '120px' },
            width: 'auto',
            marginBottom: '-4px',
          }}
        />
      </Box>
      <TextField
        fullWidth
        multiline
        rows={8}
        variant="outlined"
        placeholder="e.g., Explain the theory of relativity to a 5-year-old in a single paragraph."
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'background.paper',
            fontSize: '1.1rem',
            fontFamily: 'typography.monospace.fontFamily'
          }
        }}
      />
      <Box sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { sm: 'center' },
        mt: 1,
        gap: 2,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'space-between', width: { xs: '100%', sm: 'auto' } }}>
          <FormControlLabel
            control={
              <Switch
                checked={isSourceMaterial}
                onChange={(e) => setIsSourceMaterial(e.target.checked)}
                name="sourceMaterialSwitch"
                color="secondary"
              />
            }
            label={<Typography variant="body2">Includes source/context</Typography>}
          />
          <Chip label={`${charCount} characters`} variant="outlined" size="small" />
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={onAnalyze}
          disabled={!prompt.trim() || isLoading}
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          {isLoading ? 'Analyzing...' : 'Analyze Prompt'}
        </Button>
      </Box>
    </Box>
  );
}

export default PromptInput;